var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBm = function SvgBm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 5.739v4.047L7.826 5.74H12ZM6.261 12h3.525L6.261 7.304l-.522 3.652L6.261 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.969 12.001H12v-.032l-.032.032ZM11.999 6.261V.001h-.002C5.37 0-.001 5.373-.001 12h6.26V8.474l3.526 3.526h2.182l.032-.033V9.787L8.473 6.261H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.07 1.565a12.057 12.057 0 0 0-4.506 4.506v6.45h3.13V4.697h7.827v-3.13h-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m12.476 11-4.74-4.74H6.26l6.216 6.216V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M13.565 6.26v5.739c0 2.796 7.305 2.796 7.305 0v-5.74h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M13.565 12c0 2.796 3.653 3.653 3.653 3.653S20.87 14.796 20.87 12h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "m17.217 9.704-1.695.73V12l1.695 1.044L18.913 12v-1.565l-1.696-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M18.913 8.869H15.52v1.565h3.392V8.869Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBm;